import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorCurrentDealState = (state: RootState) => state.currentDeal;

export const selectorCurrentDealItem = createSelector(
  selectorCurrentDealState,
  (currentDealState) => currentDealState.item
);

export const selectorCurrentDealIsLoading = createSelector(
  selectorCurrentDealState,
  (dealsState) => dealsState.isLoading
);

